module.exports = __webpack_public_path__ + "img/empreendimento-logo-13.3101ddb5.png";